<template>
  <div class="content-430">
    <div class="class-form-head">
      退款设置
    </div>
    <div class="class-form-content">
      <Form ref="refundSettingInfo" :model="refundSettingInfo" label-position="right" :label-width="120" :rules="refundSettingInfoRule" @on-validate="getFormValidate">
        <FormItem
          label="退款申请许可"
          prop="enableRefund"
        >
          <RadioGroup
            v-model="refundSettingInfo.enableRefund"
          >
            <Radio :label="0">不允许</Radio>
            <Radio :label="1">允许</Radio>
          </RadioGroup>
          <div>若不允许则家长无法在小程序上申请退款，不展示申请退款入口</div>
        </FormItem>
        <FormItem
          v-if="refundSettingInfo.enableRefund == 1"
          label="申请时间限制"
          prop="refundDeadline"
        >
          <RadioGroup
            v-model="timeLimitStu"
            @on-change="handleTimeLimitStuSelect"
          >
            <Radio :label="1">限制时间</Radio>
            <!-- <Radio :label="2">不限制时间</Radio> -->
          </RadioGroup>
          <div>
            <DatePicker
              v-show="timeLimitStu == 1"
              v-model="refundSettingInfo.refundDeadlineShow"
              type="datetime"
              placeholder="选择退款申请截止时间"
              class="w-121"
              :options="options"
              @on-change="handleGetDeadLine"
            ></DatePicker>
          </div>
          <div>家长仅能在退款申请截止时间前申请退款，不展示申请退款入口</div>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['AddCommodityInstance'],
  props: {
    exsitOrder: {
      type: Boolean,
      default: false
    }, // 商品是否已被购买，是否存在订单
    value: {
      type: Object,
      default: () => {
        return {
          classroomTotal: '' // 累计课时
        };
      }
    }, // v-model的值
    validatePass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 报名截止时间验证
    const validaterefundDeadline = (rule, value, callback) => {
      console.log(this.refundSettingInfo.enableRefund, '验证了报名截止时间----');
      if (this.refundSettingInfo.enableRefund === 1 && this.timeLimitStu === 1 && !value) {
        callback(new Error('请选择退款申请截止时间'));
      } else {
        callback();
      }
    };
    return {
      refundSettingInfoRule: {
        enableRefund: [{ required: true, message: '请设置退款申请许可', type: 'number', trigger: 'change' }],
        refundDeadline: [{ validator: validaterefundDeadline, trigger: 'change' }]
      },
      refundSettingInfoRequired: {},
      timeLimitStu: 1, // 是否限制时间
      // 设置不可选时间
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      }
    };
  },
  computed: {
    refundSettingInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    } // 课程信息
  },
  watch: {
    'refundSettingInfo.enableRefund'(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.refundSettingInfo.validateField('refundDeadline');
        });
      } else {
        this.refundSettingInfoRequired['refundDeadline'].status = true;
      }
    }
  },
  created() {
    this.dealFormRequire();
  },
  mounted() {
    this.$refs.refundSettingInfo.validateField('enableRefund');
    this.AddCommodityInstance.findRuleRequireNewCourse(this, 'refundSettingInfo', '退款设置');
  },
  methods: {

    getFormValidate(prop, status, error) {
      this.refundSettingInfoRequired[prop].status = status;
      this.AddCommodityInstance.findRuleRequireNewCourse(this, 'refundSettingInfo', '退款设置');
    },
    dealFormRequire() {
      Object.keys(this.refundSettingInfoRule).forEach(item => {
        this.refundSettingInfoRequired[item] = {
          require: !!this.refundSettingInfoRule[item][0].required,
          status: item === 'refundDeadline'
        };
      });
    },
    // 申请时间限制
    handleTimeLimitStuSelect(val) {
      this.refundSettingInfo.refundDeadlineShow = '';
      this.refundSettingInfo.refundDeadline = '';
    },
    handleGetDeadLine(time) {
      this.refundSettingInfo.refundDeadline = time;
    },
    // 校验表单
    checkForm() {
      this.$refs.refundSettingInfo.validate();
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
